import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Services icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Services } from '@sravni/design-system-icons'
 *
 * <Services />
 * ```
 */
var Services = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Services", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.736 2.75h3c.69 0 1.25.56 1.25 1.25v3c0 .69-.56 1.25-1.25 1.25h-3c-.69 0-1.25-.56-1.25-1.25V4c0-.69.56-1.25 1.25-1.25ZM4.736 11.75h3c.69 0 1.25.56 1.25 1.25v3c0 .69-.56 1.25-1.25 1.25h-3c-.69 0-1.25-.56-1.25-1.25v-3c0-.69.56-1.25 1.25-1.25ZM13.736 2.75h3c.69 0 1.25.56 1.25 1.25v3c0 .69-.56 1.25-1.25 1.25h-3c-.69 0-1.25-.56-1.25-1.25V4c0-.69.56-1.25 1.25-1.25ZM13.736 11.75h3c.69 0 1.25.56 1.25 1.25v3c0 .69-.56 1.25-1.25 1.25h-3c-.69 0-1.25-.56-1.25-1.25v-3c0-.69.56-1.25 1.25-1.25Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Services };
//# sourceMappingURL=Services.js.map
